import "./App.css";
import {Menu} from "./Menu";
import {MscTerminal} from "./MscTerminal";

function App() {
  return (
    <div className='App'>
      <header className='App-header'>
        <Menu></Menu>
        <MscTerminal></MscTerminal>
      </header>
    </div>
  );
}

export default App;
